<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
    <el-form-item label="分类名称">
        <el-input v-model="formLabelAlign.typeName" size="small"></el-input>
    </el-form-item>
    <el-form-item label="分类描述">
        <el-input v-model="formLabelAlign.remark" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
 components: {},
  name: "InspectionClassificationDialog",
  data() {
    return {
        dialogVisible: false,
        title:"标题",
        labelPosition:'right',
        formLabelAlign:{},
    };
  },
  methods: {

    modification(){
        if(this.title == "添加巡检分类"){
          // POST_POLLING_ADD
      this.$http.post(this.$requestUrl.POST_POLLING_ADD,this.formLabelAlign).then((res) => {
      let data = res.data
      if(data.code == 200){
        this.dialogVisible = false
        this.$emit("dialogVisible",false)
        this.$message({
          message: data.msg,
          type: 'success'
        });
      }else{
         this.$message.error(data.msg)
      }
    }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
    })
        }else{
          // POST_POLLIMG_UPDATE
      this.$http.post(this.$requestUrl.POST_POLLIMG_UPDATE,this.formLabelAlign).then((res) => {
      let data = res.data
      if(data.code == 200){
        this.dialogVisible = false
        this.$emit("dialogVisible",false)
       this.$message({
          message: data.msg,
          type: 'success'
        });
      }else{
         this.$message.error(data.msg)
      }
    }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
    })
        }
    },
    handleClose(done) {
      this.dialogVisible = false
    },

  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {

  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>